import { render } from "./StreamsWidgetVodTab.vue?vue&type=template&id=af4ebc94"
import script from "./StreamsWidgetVodTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsWidgetVodTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamsWidgetVodTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af4ebc94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af4ebc94', __exports__)) {
    api.reload('af4ebc94', __exports__)
  }
  
  module.hot.accept("./StreamsWidgetVodTab.vue?vue&type=template&id=af4ebc94", () => {
    api.rerender('af4ebc94', render)
  })

}


export default __exports__